import DashboardLayout from "../../layouts/Dashboard";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getFacultiesContactInformation } from "../../Requests/faculty-settings-requests";
import { useMemo } from "react";

export const FacultiesContactInformationPage = () => {
	const {
		t,
		i18n: { language },
	} = useTranslation();

	const { data: facultiesContactInformation } = useQuery(
		[getFacultiesContactInformation],
		() => getFacultiesContactInformation()
	);

	const filteredContactInformation = useMemo(
		() =>
			facultiesContactInformation?.filter(
				(contactInformation) =>
					contactInformation.phone ||
					contactInformation.email ||
					contactInformation.contactPersonName
			),
		[facultiesContactInformation]
	);

	return (
		<DashboardLayout>
			<Col
				style={{
					width: "100%",
					paddingLeft: "10%",
					marginTop: "2rem",
					marginBottom: "2rem",
				}}
			>
				<Row>
					<Col>
						<h1>{t("facultySettings.facultiesContactInformation")}</h1>
					</Col>
				</Row>
				{filteredContactInformation?.map((contactInformation) => (
					<>
						<Row>
							<h2>
								{language === "ro"
									? contactInformation.nameRo
									: contactInformation.nameEn}
								:
							</h2>
						</Row>
						{contactInformation.contactPersonName && (
							<Row style={{ fontSize: "1rem", marginLeft: "2rem" }}>
								{t("facultySettings.contactPersonName")}:{" "}
								{contactInformation.contactPersonName}
							</Row>
						)}
						{contactInformation.phone && (
							<Row style={{ fontSize: "1rem", marginLeft: "2rem" }}>
								{t("facultySettings.phone")}: {contactInformation.phone}
							</Row>
						)}
						{contactInformation.email && (
							<Row
								style={{
									fontSize: "1rem",
									marginLeft: "2rem",
									marginBottom: "1rem",
								}}
							>
								{t("facultySettings.email")}:
								<a
									href={`mailto:${contactInformation.email}`}
									style={{ fontSize: "1rem", marginLeft: "4px" }}
								>
									{contactInformation.email}
								</a>
							</Row>
						)}
					</>
				))}
				<Row>
					<Col></Col>
				</Row>
			</Col>
		</DashboardLayout>
	);
};
